(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    var mount = document.querySelector('[data-cart-drawer-root]');
    if (!mount) return;

    var cfgEl = mount.querySelector('script[id^="cart-drawer-config-"]');
    var cfg = {};
    try {
      cfg = cfgEl ? JSON.parse(cfgEl.textContent) : {};
    } catch (e) {
      cfg = {};
    }
    var ROOT = cfg.rootUrl || '/';
    if (ROOT.slice(-1) !== '/') ROOT += '/';

    var previousFocus = null;
    var lineUpdateLock = false;

    function getAddingLabel() {
      return (cfg && cfg.addingLabel) || 'Adding to cart';
    }

    function setButtonLoading(btn, loading) {
      if (!btn || btn.tagName !== 'BUTTON') return;
      if (loading) {
        if (!btn.dataset.fortyAtcLabel) btn.dataset.fortyAtcLabel = btn.innerHTML;
        btn.disabled = true;
        btn.classList.add('forty-atc-loading');
        btn.setAttribute('aria-busy', 'true');
        btn.innerHTML = '';
        var spin = document.createElement('span');
        spin.className = 'forty-atc-spinner';
        spin.setAttribute('aria-hidden', 'true');
        var sr = document.createElement('span');
        sr.className = 'visually-hidden';
        sr.textContent = getAddingLabel();
        btn.appendChild(spin);
        btn.appendChild(sr);
      } else {
        btn.disabled = false;
        btn.classList.remove('forty-atc-loading');
        btn.removeAttribute('aria-busy');
        if (btn.dataset.fortyAtcLabel) {
          btn.innerHTML = btn.dataset.fortyAtcLabel;
          delete btn.dataset.fortyAtcLabel;
        }
      }
    }

    function getCheckoutLoadingLabel() {
      return (cfg && cfg.checkoutLoadingLabel) || 'Going to checkout';
    }

    function setCheckoutButtonLoading(btn, loading) {
      if (!btn || btn.tagName !== 'BUTTON') return;
      if (loading) {
        if (!btn.dataset.fortyCheckoutHtml) btn.dataset.fortyCheckoutHtml = btn.innerHTML;
        btn.disabled = true;
        btn.classList.add('forty-atc-loading');
        btn.setAttribute('aria-busy', 'true');
        btn.innerHTML = '';
        var spin = document.createElement('span');
        spin.className = 'forty-atc-spinner';
        spin.setAttribute('aria-hidden', 'true');
        var sr = document.createElement('span');
        sr.className = 'visually-hidden';
        sr.textContent = getCheckoutLoadingLabel();
        btn.appendChild(spin);
        btn.appendChild(sr);
      } else {
        btn.disabled = false;
        btn.classList.remove('forty-atc-loading');
        btn.removeAttribute('aria-busy');
        if (btn.dataset.fortyCheckoutHtml) {
          btn.innerHTML = btn.dataset.fortyCheckoutHtml;
          delete btn.dataset.fortyCheckoutHtml;
        }
      }
    }

    function getCheckoutUrl() {
      return (cfg && cfg.checkoutUrl) || '/checkout';
    }

    function onCheckoutClick(e) {
      var btn = e.target.closest('[data-cart-drawer-checkout]');
      if (!btn || !btn.closest('[data-cart-drawer-root]')) return;
      e.preventDefault();
      setCheckoutButtonLoading(btn, true);
      window.location.assign(getCheckoutUrl());
    }

    window.addEventListener('pageshow', function (ev) {
      if (!ev.persisted) return;
      var btn = document.querySelector('.cart-drawer__checkout.forty-atc-loading');
      if (btn) setCheckoutButtonLoading(btn, false);
    });

    function setAllLineControlsDisabled(disabled) {
      var r = getRoot();
      if (!r) return;
      var panel = r.querySelector('[data-cart-drawer-panel]') || r;
      panel.querySelectorAll('[data-line-decrease], [data-line-increase], [data-line-remove]').forEach(function (b) {
        b.disabled = disabled;
      });
      panel.querySelectorAll('[data-line-qty]').forEach(function (inp) {
        inp.disabled = disabled;
      });
    }

    function getRoot() {
      return document.querySelector('[data-cart-drawer-root]');
    }

    function qs(sel, ctx) {
      return (ctx || getRoot()).querySelector(sel);
    }

    function readCfgFromMount() {
      var el = getRoot() && getRoot().querySelector('script[id^="cart-drawer-config-"]');
      if (el && el.textContent) {
        try {
          cfg = JSON.parse(el.textContent);
          ROOT = cfg.rootUrl || ROOT;
          if (ROOT.slice(-1) !== '/') ROOT += '/';
        } catch (err) {}
      }
    }

    function sectionRenderUrl() {
      return ROOT + '?sections=cart-drawer';
    }

    function pickSectionHtml(data) {
      if (!data) return '';
      if (typeof data['cart-drawer'] === 'string') return data['cart-drawer'];
      var k = Object.keys(data)[0];
      return k ? data[k] : '';
    }

    function replaceDrawer(html) {
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var incoming = doc.querySelector('[data-cart-drawer-root]');
      var r = getRoot();
      if (!incoming || !r) return;
      r.innerHTML = incoming.innerHTML;
      readCfgFromMount();
      updateHeaderCount();
    }

    function refresh() {
      return fetch(sectionRenderUrl(), { credentials: 'same-origin' })
        .then(function (resp) {
          return resp.json();
        })
        .then(function (data) {
          var h = pickSectionHtml(data);
          if (h) replaceDrawer(h);
        })
        .catch(function () {});
    }

    function updateHeaderCount() {
      return fetch(ROOT + 'cart.js', { credentials: 'same-origin' })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          var n = cart.item_count || 0;
          var wrap = document.querySelector('.header__cart');
          var badge = document.querySelector('.header__cart-count');
          var txt = document.querySelector('.header__cart-count-text');
          if (n > 0) {
            if (!badge && wrap) {
              badge = document.createElement('span');
              badge.className = 'header__cart-count position-absolute d-flex align-items-center justify-content-center rounded-pill';
              badge.setAttribute('aria-hidden', 'true');
              txt = document.createElement('span');
              txt.className = 'header__cart-count-text';
              badge.appendChild(txt);
              wrap.appendChild(badge);
            }
            if (txt) txt.textContent = n > 99 ? '99' : String(n);
          } else if (badge) {
            badge.remove();
          }
        })
        .catch(function () {});
    }

    function openDrawer() {
      var r = getRoot();
      if (!r) return;
      previousFocus = document.activeElement;
      r.classList.add('is-open');
      r.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('cart-drawer-open');
      var panel = qs('[data-cart-drawer-panel]', r);
      if (panel) panel.focus();
    }

    function closeDrawer() {
      var r = getRoot();
      if (!r) return;
      r.classList.remove('is-open');
      r.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('cart-drawer-open');
      if (previousFocus && previousFocus.focus) previousFocus.focus();
    }

    function postJSON(url, body) {
      return fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      }).then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw j;
          return j;
        });
      });
    }

    function changeLine(line, quantity) {
      if (lineUpdateLock) return Promise.resolve();
      lineUpdateLock = true;
      setAllLineControlsDisabled(true);
      return postJSON(ROOT + 'cart/change.js', { line: line, quantity: quantity })
        .then(function () {
          return refresh();
        })
        .catch(function () {})
        .finally(function () {
          lineUpdateLock = false;
          setAllLineControlsDisabled(false);
        });
    }

    function onSubmitAddToCart(e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      var action = form.getAttribute('action') || '';
      if (action.indexOf('cart/add') === -1) return;
      if (form.closest('[data-skip-ajax-cart]')) return;
      e.preventDefault();
      var submitBtn = e.submitter;
      if (!submitBtn || submitBtn.tagName !== 'BUTTON') {
        submitBtn = form.querySelector('button[type="submit"][name="add"]');
      }
      if (!submitBtn || submitBtn.tagName !== 'BUTTON') {
        submitBtn = form.querySelector('button[type="submit"]');
      }
      setButtonLoading(submitBtn, true);
      var fd = new FormData(form);
      fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        body: fd,
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      })
        .then(function (r) {
          return r.json().then(function (j) {
            if (!r.ok) throw j;
            return j;
          });
        })
        .then(function () {
          return refresh();
        })
        .then(function () {
          openDrawer();
          return updateHeaderCount();
        })
        .catch(function (err) {
          var msg =
            err && err.description
              ? err.description
              : err && err.message
                ? err.message
                : 'Could not add to cart';
          window.alert(msg);
        })
        .finally(function () {
          setButtonLoading(submitBtn, false);
        });
    }

    document.addEventListener('submit', onSubmitAddToCart);
    document.addEventListener('click', onCheckoutClick);

    document.addEventListener(
      'paste',
      function (e) {
        var t = e.target;
        if (t && t.getAttribute && t.getAttribute('data-line-qty') !== null) e.preventDefault();
      },
      true
    );
    document.addEventListener(
      'drop',
      function (e) {
        var t = e.target;
        if (t && t.getAttribute && t.getAttribute('data-line-qty') !== null) e.preventDefault();
      },
      true
    );

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-drawer-open]')) {
        e.preventDefault();
        refresh().then(function () {
          openDrawer();
        });
        return;
      }
      if (e.target.closest('[data-cart-drawer-close]')) {
        e.preventDefault();
        closeDrawer();
        return;
      }
      var dec = e.target.closest('[data-line-decrease]');
      if (dec) {
        e.preventDefault();
        if (lineUpdateLock) return;
        var lineD = parseInt(dec.getAttribute('data-line-decrease'), 10);
        var inputD = qs('input[data-line-index="' + lineD + '"]');
        var qd = inputD ? parseInt(inputD.value, 10) || 0 : 1;
        changeLine(lineD, Math.max(0, qd - 1)).then(function () {
          return updateHeaderCount();
        });
        return;
      }
      var inc = e.target.closest('[data-line-increase]');
      if (inc) {
        e.preventDefault();
        if (lineUpdateLock) return;
        var lineI = parseInt(inc.getAttribute('data-line-increase'), 10);
        var inputI = qs('input[data-line-index="' + lineI + '"]');
        var qi = inputI ? parseInt(inputI.value, 10) || 0 : 0;
        changeLine(lineI, qi + 1).then(function () {
          return updateHeaderCount();
        });
        return;
      }
      var rm = e.target.closest('[data-line-remove]');
      if (rm) {
        e.preventDefault();
        if (lineUpdateLock) return;
        var lineR = parseInt(rm.getAttribute('data-line-remove'), 10);
        changeLine(lineR, 0).then(function () {
          return updateHeaderCount();
        });
        return;
      }
      var tbtn = e.target.closest('[data-tier-tooltip]');
      if (tbtn) {
        e.preventDefault();
        var r0 = getRoot();
        if (!r0) return;
        var panel = r0.querySelector('[data-tier-tooltip-panel]');
        if (!panel) return;
        var hidden = panel.hasAttribute('hidden');
        if (hidden) {
          panel.removeAttribute('hidden');
          tbtn.setAttribute('aria-expanded', 'true');
        } else {
          panel.setAttribute('hidden', '');
          tbtn.setAttribute('aria-expanded', 'false');
        }
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var r = getRoot();
      if (r && r.classList.contains('is-open')) closeDrawer();
    });

    updateHeaderCount();

    window.FortyCartDrawer = {
      open: function () {
        return refresh().then(function () {
          openDrawer();
        });
      },
      close: closeDrawer,
      refresh: refresh,
    };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (window.FortyCartDrawer && typeof window.FortyCartDrawer.open === 'function') {
      window.FortyCartDrawer.open();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-description"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const collapsibles = document.querySelectorAll('[data-product-description-collapsible]');

    collapsibles.forEach((content) => {
      const section = content.closest('.product-description-section');
      if (!section) return;

      const toggle = section.querySelector('.product-description-section__toggle');
      if (!toggle) return;

      const showMoreLabel = toggle.dataset.showMore || '';
      const showLessLabel = toggle.dataset.showLess || '';

      toggle.addEventListener('click', () => {
        const isExpanded = content.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
        toggle.textContent = isExpanded ? showLessLabel : showMoreLabel;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  function productReviewsInitSwiper() {
    if (typeof Swiper === 'undefined') {
      return;
    }
    document.querySelectorAll('.product-reviews__swiper-root').forEach(function (root) {
      if (root.getAttribute('data-swiper-initialized') === 'true') {
        return;
      }
      var pag = root.querySelector('.product-reviews__pagination');
      new Swiper(root, {
        slidesPerView: 'auto',
        spaceBetween: 15,
        pagination: pag
          ? {
              el: pag,
              clickable: true,
            }
          : undefined,
        watchOverflow: true,
      });
      root.setAttribute('data-swiper-initialized', 'true');
    });
  }
  function productReviewsOnReady() {
    productReviewsInitSwiper();
  }
  if (window.jQuery) {
    jQuery(function () {
      productReviewsOnReady();
    });
  } else {
    document.addEventListener('DOMContentLoaded', productReviewsOnReady);
  }
  document.addEventListener('shopify:section:load', productReviewsOnReady);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  function productGalleryThumbsInit() {
    if (typeof Swiper === 'undefined') {
      return;
    }
    document.querySelectorAll('.product-gallery__root').forEach(function (root) {
      var mainEl = root.querySelector('.product-gallery__main');
      var thumbsEl = root.querySelector('.product-gallery__thumbs');
      if (!mainEl) {
        return;
      }
      var mainSlideNodes = mainEl.querySelectorAll('.swiper-slide');
      if (mainSlideNodes.length < 1) {
        return;
      }
      var nextEl = mainEl.querySelector('.product-gallery__next');
      var prevEl = mainEl.querySelector('.product-gallery__prev');
      var thumbCount = thumbsEl
        ? thumbsEl.querySelectorAll('.swiper-slide').length
        : 0;
      var thumbSwiper = null;
      if (thumbsEl && thumbCount > 0) {
        thumbSwiper = new Swiper(thumbsEl, {
          slidesPerView: 4.2,
          spaceBetween: 8,
          freeMode: true,
          watchSlidesProgress: true,
          slideToClickedSlide: true,
        });
      }
      new Swiper(mainEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        navigation:
          mainSlideNodes.length > 1
            ? {
                nextEl: nextEl,
                prevEl: prevEl,
              }
            : {},
        thumbs: thumbSwiper
          ? {
              swiper: thumbSwiper,
            }
          : undefined,
      });
    });
  }
  if (window.jQuery) {
    jQuery(function () {
      productGalleryThumbsInit();
    });
  } else {
    document.addEventListener('DOMContentLoaded', productGalleryThumbsInit);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-modal"]) return;
  try {
    
  (function () {
    var dialog = document.querySelector('[data-search-modal-root]');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    var previousFocus = null;
    var predictiveEnabled = dialog.getAttribute('data-predictive-enabled') !== 'false';
    var predictiveSectionId = dialog.getAttribute('data-predictive-section-id') || 'predictive-search';
    var predictiveRoot = dialog.querySelector('[data-search-modal-predictive]');
    var predictiveResults = dialog.querySelector('[data-search-modal-predictive-results]');
    var predictiveLoading = dialog.querySelector('[data-search-modal-predictive-loading]');
    var predictiveStatus = dialog.querySelector('[data-search-modal-predictive-status]');
    var defaultContent = dialog.querySelector('[data-search-modal-default]');
    var searchInput = dialog.querySelector('[data-search-modal-input]');
    var debounceTimer = null;
    var abortController = null;
    var activeIndex = -1;

    function qs(sel, root) {
      return (root || document).querySelector(sel);
    }

    function qsa(sel, root) {
      return Array.prototype.slice.call((root || document).querySelectorAll(sel));
    }

    function getPredictiveUrl() {
      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        return window.Shopify.routes.root + 'search/suggest';
      }
      return '/search/suggest';
    }

    function clearPredictiveState() {
      if (abortController) {
        abortController.abort();
        abortController = null;
      }
      if (predictiveResults) predictiveResults.innerHTML = '';
      if (predictiveLoading) predictiveLoading.hidden = true;
      if (predictiveStatus) predictiveStatus.textContent = '';
      if (predictiveRoot) predictiveRoot.hidden = true;
      if (defaultContent) defaultContent.hidden = false;
      if (searchInput) searchInput.setAttribute('aria-expanded', 'false');
      activeIndex = -1;
    }

    function getOptions() {
      return qsa('[role="option"] a, .predictive-search__view-all', predictiveResults);
    }

    function setActiveOption(index) {
      var options = getOptions();
      options.forEach(function (el) {
        el.classList.remove('is-active');
      });
      if (index < 0 || index >= options.length) {
        activeIndex = -1;
        return;
      }
      activeIndex = index;
      options[index].classList.add('is-active');
      options[index].scrollIntoView({ block: 'nearest' });
    }

    function showPredictiveLoading(show) {
      if (predictiveLoading) predictiveLoading.hidden = !show;
    }

    function fetchPredictiveResults(term) {
      if (!predictiveEnabled || !predictiveRoot || !predictiveResults) return;

      if (abortController) abortController.abort();
      abortController = new AbortController();

      showPredictiveLoading(true);
      if (defaultContent) defaultContent.hidden = true;
      predictiveRoot.hidden = false;
      if (searchInput) searchInput.setAttribute('aria-expanded', 'true');

      var params = new URLSearchParams();
      params.set('q', term);
      params.set('section_id', predictiveSectionId);
      params.set('resources[type]', 'product,query,collection,page,article');
      params.set('resources[limit]', '6');
      params.set('resources[limit_scope]', 'each');
      params.set('resources[options][unavailable_products]', 'hide');

      fetch(getPredictiveUrl() + '?' + params.toString(), {
        signal: abortController.signal,
        headers: { Accept: 'text/html' },
      })
        .then(function (response) {
          if (!response.ok) throw new Error(String(response.status));
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var section = doc.querySelector('#shopify-section-' + predictiveSectionId);
          predictiveResults.innerHTML = section ? section.innerHTML : '';
          activeIndex = -1;
          if (predictiveStatus) {
            var count = getOptions().length;
            predictiveStatus.textContent = count
              ? count + ' results'
              : '';
          }
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          clearPredictiveState();
        })
        .finally(function () {
          showPredictiveLoading(false);
          abortController = null;
        });
    }

    function onSearchInput() {
      if (!searchInput || !predictiveEnabled) return;
      var term = searchInput.value.trim();
      window.clearTimeout(debounceTimer);
      if (!term.length) {
        clearPredictiveState();
        return;
      }
      debounceTimer = window.setTimeout(function () {
        fetchPredictiveResults(term);
      }, 300);
    }

    function openModal() {
      if (dialog.open) return;
      previousFocus = document.activeElement;
      dialog.showModal();
      document.documentElement.classList.add('search-modal-open');
      if (searchInput) {
        window.setTimeout(function () {
          searchInput.focus();
        }, 0);
      }
    }

    function closeModal() {
      if (!dialog.open) return;
      clearPredictiveState();
      if (searchInput) searchInput.value = '';
      dialog.close();
      document.documentElement.classList.remove('search-modal-open');
      if (previousFocus && previousFocus.focus) previousFocus.focus();
    }

    function submitSearch(term) {
      var input = qs('[data-search-modal-input]', dialog);
      var form = qs('[data-search-modal-form]', dialog);
      if (!input || !form) return;
      input.value = term;
      form.submit();
    }

    if (searchInput) {
      searchInput.addEventListener('input', onSearchInput);
      searchInput.addEventListener('keydown', function (e) {
        if (!predictiveRoot || predictiveRoot.hidden) return;
        var options = getOptions();
        if (!options.length) return;

        if (e.key === 'ArrowDown') {
          e.preventDefault();
          setActiveOption(activeIndex + 1 >= options.length ? 0 : activeIndex + 1);
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          setActiveOption(activeIndex - 1 < 0 ? options.length - 1 : activeIndex - 1);
        } else if (e.key === 'Enter' && activeIndex >= 0) {
          e.preventDefault();
          options[activeIndex].click();
        }
      });
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-search-modal-open]')) {
        e.preventDefault();
        openModal();
        return;
      }
      if (e.target.closest('[data-search-modal-close]')) {
        e.preventDefault();
        closeModal();
        return;
      }
      var suggestion = e.target.closest('[data-search-suggestion]');
      if (suggestion && dialog.contains(suggestion)) {
        e.preventDefault();
        submitSearch(suggestion.getAttribute('data-search-suggestion') || suggestion.textContent.trim());
        return;
      }
      var next = e.target.closest('[data-search-chip-next]');
      if (next && dialog.contains(next)) {
        e.preventDefault();
        var row = next.closest('.search-modal__chip-row');
        var track = row && row.querySelector('[data-search-chip-track]');
        if (track) track.scrollBy({ left: 180, behavior: 'smooth' });
      }
    });

    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) closeModal();
    });

    dialog.addEventListener('cancel', function (e) {
      e.preventDefault();
      closeModal();
    });

    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('search-modal-open');
      clearPredictiveState();
    });

    window.FortySearchModal = {
      open: openModal,
      close: closeModal,
    };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["you-might-love"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var STORAGE_KEY = 'forty:recently-viewed';
    var MAX_RECENT = 12;

    function applyCardColors(root, container) {
      if (!root || !container) return;
      var accent = root.dataset.accentColor;
      var background = root.dataset.cardBackground;
      container.querySelectorAll('.collection-catalog-card').forEach(function (card) {
        if (accent) card.style.setProperty('--collection-catalog-accent', accent);
        if (background) card.style.setProperty('--collection-catalog-card-bg', background);
      });
    }

    function setupShowMore(panel, initialLimit) {
      if (!panel) return;
      var grid = panel.querySelector('[role="list"]');
      var button = panel.querySelector('[data-you-might-love-show-more]');
      if (!grid || !button) return;

      var items = grid.querySelectorAll(':scope > li');
      if (items.length <= initialLimit) {
        button.hidden = true;
        return;
      }

      items.forEach(function (item, index) {
        if (index >= initialLimit) item.classList.add('you-might-love__grid-item--hidden');
      });

      button.hidden = false;
      button.addEventListener(
        'click',
        function () {
          items.forEach(function (item) {
            item.classList.remove('you-might-love__grid-item--hidden');
          });
          button.hidden = true;
        },
        { once: true }
      );
    }

    function saveRecentProduct(root) {
      var handle = root.dataset.productHandle;
      if (!handle) return;

      var items = [];
      try {
        items = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
      } catch (error) {
        items = [];
      }

      items = items.filter(function (item) {
        return item && item !== handle;
      });
      items.push(handle);

      if (items.length > MAX_RECENT) {
        items = items.slice(items.length - MAX_RECENT);
      }

      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    }

    function loadRecentlyViewed(root) {
      var grid = root.querySelector('[data-you-might-love-recently-grid]');
      var emptyEl = root.querySelector('[data-you-might-love-recently-empty]');
      var panel = root.querySelector('[data-you-might-love-panel="recently-viewed"]');
      if (!grid || grid.dataset.loaded === 'true') return;

      grid.dataset.loaded = 'true';

      var currentHandle = root.dataset.productHandle;
      var cardSection = root.dataset.cardSection;
      var initialLimit = parseInt(root.dataset.initialLimit, 10) || 4;
      var items = [];

      try {
        items = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
      } catch (error) {
        items = [];
      }

      items = items.filter(function (handle) {
        return handle && handle !== currentHandle;
      });
      items.reverse();

      if (items.length === 0) {
        if (emptyEl) emptyEl.hidden = false;
        return;
      }

      if (emptyEl) emptyEl.hidden = true;

      Promise.all(
        items.map(function (handle) {
          return fetch('/products/' + encodeURIComponent(handle) + '?sections=' + cardSection)
            .then(function (response) {
              return response.json();
            })
            .then(function (json) {
              var html = json[cardSection];
              if (!html) return '';
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var item = doc.querySelector('li');
              return item ? item.outerHTML : html;
            })
            .catch(function () {
              return '';
            });
        })
      ).then(function (parts) {
        grid.innerHTML = parts.filter(Boolean).join('');
        applyCardColors(root, grid);
        setupShowMore(panel, initialLimit);
      });
    }

    function fetchRecommendations(root) {
      var url = root.dataset.recommendationsUrl;
      var initialLimit = parseInt(root.dataset.initialLimit, 10) || 4;
      var panel = root.querySelector('[data-you-might-love-panel="recommendations"]');
      var grid = root.querySelector('[data-you-might-love-recommendations-grid]');
      var emptyEl = root.querySelector('[data-you-might-love-recommendations-empty]');

      if (!url || !grid) {
        setupShowMore(panel, initialLimit);
        return;
      }

      fetch(url)
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var freshGrid = doc.querySelector('[data-you-might-love-recommendations-grid]');
          if (freshGrid) {
            grid.innerHTML = freshGrid.innerHTML;
          }

          var hasItems = grid.querySelectorAll(':scope > li').length > 0;
          if (emptyEl) emptyEl.hidden = hasItems;

          setupShowMore(panel, initialLimit);
        })
        .catch(function () {
          var hasItems = grid.querySelectorAll(':scope > li').length > 0;
          if (emptyEl) emptyEl.hidden = hasItems;
          setupShowMore(panel, initialLimit);
        });
    }

    function initSection(root) {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      var tabs = root.querySelectorAll('[data-you-might-love-tab]');
      var panels = root.querySelectorAll('[data-you-might-love-panel]');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.dataset.youMightLoveTab;

          tabs.forEach(function (item) {
            var selected = item.dataset.youMightLoveTab === target;
            item.setAttribute('aria-selected', selected ? 'true' : 'false');
            item.tabIndex = selected ? 0 : -1;
            item.classList.toggle('you-might-love__tab--active', selected);
          });

          panels.forEach(function (panel) {
            panel.hidden = panel.dataset.youMightLovePanel !== target;
          });

          if (target === 'recently-viewed') {
            loadRecentlyViewed(root);
          }
        });
      });

      saveRecentProduct(root);
      fetchRecommendations(root);

      var recommendationsPanel = root.querySelector('[data-you-might-love-panel="recommendations"]');
      var recommendationsGrid = root.querySelector('[data-you-might-love-recommendations-grid]');
      var recommendationsEmpty = root.querySelector('[data-you-might-love-recommendations-empty]');
      if (recommendationsGrid && recommendationsEmpty) {
        var hasFallbackItems = recommendationsGrid.querySelectorAll(':scope > li').length > 0;
        recommendationsEmpty.hidden = hasFallbackItems;
        if (hasFallbackItems) {
          setupShowMore(recommendationsPanel, parseInt(root.dataset.initialLimit, 10) || 4);
        }
      }
    }

    document.querySelectorAll('[data-you-might-love]').forEach(initSection);

    document.addEventListener('shopify:section:load', function (event) {
      event.target.querySelectorAll('[data-you-might-love]').forEach(initSection);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
